import { useEffect, useState } from 'react';
import { getCdnUrl } from 'utils';

const useImageFallback = (image: string, fallbackImage?: string) => {
  const [src, setSrc] = useState(null);

  const onError = () => {
    if (!fallbackImage) return;
    setSrc(fallbackImage);
  };

  useEffect(() => {
    setSrc(getCdnUrl(image, fallbackImage));
  }, [image, fallbackImage]);

  return { src, onError };
};

export default useImageFallback;
